/**
 * Utilidades específicas para productos
 */

/**
 * Obtiene valores únicos de un campo de una lista de productos
 * @param {Array} productos - Lista de productos
 * @param {string} campo - Campo del cual extraer valores únicos
 * @returns {Array} Array de valores únicos ordenados
 */
export const obtenerValoresUnicos = (productos, campo) => {
  const valores = new Set();
  productos.forEach(producto => {
    const valor = producto[campo];
    if (valor && valor.toString().trim() !== '') {
      valores.add(valor);
    }
  });
  return Array.from(valores).sort();
};

/**
 * Verifica si el precio es uniforme en una lista de productos
 * @param {Array} productos - Lista de productos
 * @returns {Object|null} { precio } si son uniformes, null si no
 */
export const verificarPreciosUniforme = (productos) => {
  if (!productos || productos.length === 0) return null;

  const primerPrecio = productos[0].precio;
  const primerPrecioNum = primerPrecio != null ? Number(primerPrecio) : null;

  const todosMismoPrecio = productos.every((p) => {
    const precio = p.precio != null ? Number(p.precio) : null;
    return precio === primerPrecioNum;
  });

  if (todosMismoPrecio) {
    return {
      precio: primerPrecio != null ? String(primerPrecio) : '',
    };
  }

  return null;
};

/**
 * Obtiene el nombre de un producto (nombre, título, modelo o id)
 * @param {Object} producto - Objeto producto
 * @returns {string} Nombre del producto
 */
export const obtenerNombreProducto = (producto) => {
  return producto.nombre || producto.titulo || producto.modelo || producto.id || 'Sin nombre';
};

